"use client";

import { useCallback, useSyncExternalStore } from "react";

// one MediaQueryList per query; `matches` is live
const lists = new Map();

const get_list = (query) => {
	if (!query || typeof window === "undefined" || typeof window.matchMedia !== "function") return null;
	let list = lists.get(query);
	if (!list) {
		list = window.matchMedia(query);
		lists.set(query, list);
	}
	return list;
};

// Whether a CSS media query matches, updated on change. Base of `useIsMobile` / `useIsDesktop` (chawk-bazar, ciseco
// and jument had a copy each). The server has no viewport: it and the hydration pass get `server_value`
// (default false), then React re-renders once with the real value, so there is no hydration mismatch.
export default function useMediaQuery(query, { server_value = false } = {}) {
	const subscribe = useCallback(
		(on_change) => {
			const list = get_list(query);
			if (!list) return () => {};
			if (list.addEventListener) {
				list.addEventListener("change", on_change);
				return () => list.removeEventListener("change", on_change);
			}
			list.addListener(on_change);
			return () => list.removeListener(on_change);
		},
		[query],
	);

	const get_snapshot = () => {
		const list = get_list(query);
		return list ? list.matches : server_value;
	};

	return useSyncExternalStore(subscribe, get_snapshot, () => server_value);
}
